if (!customElements.get("design-your-own-image")) {
  customElements.define(
    "design-your-own-image",
    class DesignYourOwnImage extends HTMLElement {
      get productForm() {
        return document.forms[this.getAttribute("form")];
      }

      get partsMaskImages() {
        return Array.from(this.querySelectorAll("[data-parts-mask-label]"));
      }

      connectedCallback() {
        if (!this.productForm) return;

        this.onDesignYourOwnChangeListener =
          this.onDesignYourOwnChange.bind(this);
        this.productForm.addEventListener(
          "designYourOwn:change",
          this.onDesignYourOwnChangeListener
        );
      }

      disconnectedCallback() {
        if (!this.productForm) return;

        this.productForm.removeEventListener(
          "designYourOwn:change",
          this.onDesignYourOwnChangeListener
        );
      }

      onDesignYourOwnChange(event) {
        const picker = event.detail.picker;
        this.partsMaskImages.forEach((part) => {
          const selectedInput = picker.querySelector(
            `input[data-component-label="${part.getAttribute(
              "data-parts-mask-label"
            )}"]:checked`
          );
          const backgroundColor =
            selectedInput?.getAttribute("data-swatch-background") ||
            "transparent";
          const backgroundImage = selectedInput?.getAttribute(
            "data-swatch-background-image"
          )
            ? `url(${selectedInput.getAttribute(
                "data-swatch-background-image"
              )})`
            : "none";
          part.style.setProperty("--background-color", backgroundColor);
          part.style.setProperty("--background-image", backgroundImage);
        });
      }
    }
  );
}
